import { useTranslation } from 'next-i18next';
import React from 'react';

import { useDeleteSupplierOrWorkerExpenses } from '@/modules/workingDayReconciliation/apiHooks';
import { IReconciliation } from '@/modules/workingDayReconciliation/types';
import { Avatar, Button } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Trash from '~/images/shared/Trash.svg';

interface Props {
  modalType: IReconciliation.IModalType;
  expenseId: number;
  expenseType: IReconciliation.IExpenseType;
}

const DeleteModal: React.FC<Props> = ({
  modalType,
  expenseId,
  expenseType,
}) => {
  const { mutate, isLoading } = useDeleteSupplierOrWorkerExpenses(modalType);

  const [selectedAsset] = useStore((store) => store?.asset);

  const { t } = useTranslation('common');
  const { closeModal } = useModal();

  const handleDelete = () => {
    if (selectedAsset?.id) {
      mutate(
        {
          id: selectedAsset?.id,
          expenseId,
          expenseType,
        },
        {
          onSuccess: () => closeModal(),
        }
      );
    }
  };
  return (
    <div className='flex flex-col items-center justify-center gap-16'>
      <Avatar
        size='xlg'
        className='rounded-full bg-error-100'
        icon={
          <span className='text-error-500'>
            <Trash />
          </span>
        }
        variant='single'
      />
      <span className=''>
        {modalType === 'bonus'
          ? t('sure-to-cancel-bonus-message')
          : t('sure-to-cancel-deduction-message')}
      </span>
      <div className='flex items-center gap-16'>
        <Button
          id={`submit_remove_${modalType}`}
          color='primary'
          loading={isLoading}
          size='md'
          onClick={handleDelete}
        >
          {t('yes')}
        </Button>
        <Button color='secondary' size='md' onClick={() => closeModal()}>
          {t('no')}
        </Button>
      </div>
    </div>
  );
};
export default DeleteModal;
